export const PROMO_MARKER = '{{PROMO_ITEMS}}';
export const PROMO_ASSET_ORIGIN = 'https://affilmaster.platform1.cz';

export type PromoLang = 'cs' | 'sk';

export interface PromoItem {
  key: string;
  clientId: number | null;
  name: string;
  logo: string | null;
  logoW: number | null;
  logoH: number | null;
  text: string;
  url: string;
}

export interface PromoMeta {
  country: string;
  period: string;
  items: PromoItem[];
}

const BUTTON: Record<PromoLang, string> = { cs: 'Detail zde', sk: 'Detail tu' };

export const PROMO_SUBJECT_PREFIX = 'Promo news - ';

export function isPromoTemplate(html: string | null | undefined): boolean {
  return !!html && html.includes(PROMO_MARKER);
}

export function promoLang(country: string | null | undefined): PromoLang {
  return country === 'SK' ? 'sk' : 'cs';
}

export function newPromoItem(): PromoItem {
  return { key: Math.random().toString(36).slice(2), clientId: null, name: '', logo: null, logoW: null, logoH: null, text: '', url: '' };
}

function esc(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

export function validPromoUrl(url: string): boolean {
  try {
    const u = new URL(url.trim());
    return u.protocol === 'https:' && !!u.hostname;
  } catch {
    return false;
  }
}

export function logoSrc(logo: string | null): string | null {
  if (!logo) return null;
  return /^https:\/\//.test(logo) ? logo : `${PROMO_ASSET_ORIGIN}${logo.startsWith('/') ? '' : '/'}${logo}`;
}

export function fitLogo(w: number | null, h: number | null, maxW = 88, maxH = 38): { w: number; h: number } | null {
  if (!w || !h || w < 8 || h < 8) return null;
  const scale = Math.min(maxW / w, maxH / h, 1);
  return { w: Math.round(w * scale), h: Math.round(h * scale) };
}

function renderItem(item: PromoItem, lang: PromoLang): string {
  const src = logoSrc(item.logo);
  const size = fitLogo(item.logoW, item.logoH);
  const name = esc(item.name.trim());
  const logoCell = src && size
    ? `<img class="pn-img" src="${esc(src)}" width="${size.w}" height="${size.h}" alt="${name}" style="display:inline-block;border:0;width:${size.w}px;height:${size.h}px;">`
    : `<span style="font-size:14px;font-weight:700;color:#111111;">${name}</span>`;
  return `<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="border:1px solid #e3e6ea;border-radius:12px;border-collapse:separate;margin:0 0 12px;">
<tr>
<td class="pn-logo" width="124" align="center" valign="middle" style="width:124px;padding:16px 12px;">${logoCell}</td>
<td class="pn-text" valign="middle" style="padding:16px 12px 16px 20px;border-left:1px solid #e8ebef;"><p class="pn-name" style="margin:0 0 4px;font-size:16px;line-height:1.3;font-weight:700;color:#111111;">${name}</p><p class="pn-info" style="margin:0;font-size:14px;line-height:1.45;color:#374151;">${esc(item.text.trim())}</p></td>
<td class="pn-btn" align="right" valign="middle" style="padding:16px 18px 16px 8px;white-space:nowrap;"><a class="pn-cta" href="${esc(item.url.trim())}" style="display:inline-block;background:#4f46e5;color:#ffffff;font-size:13px;line-height:1;font-weight:500;text-decoration:none;padding:11px 16px;border-radius:8px;white-space:nowrap;">${BUTTON[lang]}</a></td>
</tr></table>`;
}

export function buildPromoHtml(template: string, items: PromoItem[], lang: PromoLang): string {
  return template.replace(PROMO_MARKER, items.map((i) => renderItem(i, lang)).join('\n'));
}

export function promoIssues(items: PromoItem[]): string[] {
  const out: string[] = [];
  if (!items.length) out.push('Přidej aspoň jednoho klienta.');
  items.forEach((it, i) => {
    const n = `Řádek ${i + 1}`;
    if (!it.name.trim()) out.push(`${n}: vyber klienta.`);
    if (!it.text.trim()) out.push(`${n}: vyplň text (např. Nové promo - týden 39).`);
    if (!validPromoUrl(it.url)) out.push(`${n}: odkaz musí být platná adresa začínající https://.`);
  });
  return out;
}
